import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25d2dc21")

_pushScopeId("data-v-25d2dc21")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body card-p" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "col-xl-12" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "col-xl-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_WidgetBestSellersByQuantity = _resolveComponent("WidgetBestSellersByQuantity")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_WidgetBestSellersByRevenue = _resolveComponent("WidgetBestSellersByRevenue")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        "tab-position": 'top',
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event))
      }, {
        default: _withId(() => [
          _createVNode(_component_el_tab_pane, {
            label: `${_ctx.$t('message.BY_QUANTITY')}`,
            name: "first"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_WidgetBestSellersByQuantity, {
                    "widget-classes": "mb-5 mb-xl-8",
                    "chart-color": "primary",
                    chartHeight: "350",
                    i18n: _ctx.i18n,
                    locale: _ctx.systemLocale,
                    background: "lightcyan",
                    key: [_ctx.glob, _ctx.systemLocale],
                    data: _ctx.best_sellers,
                    link: "#"
                  }, null, 8, ["i18n", "locale", "data"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: `${_ctx.$t('message.BY_REVENUE')}`,
            name: "second"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_WidgetBestSellersByRevenue, {
                    "widget-classes": "mb-5 mb-xl-8",
                    "chart-color": "primary",
                    chartHeight: "350",
                    i18n: _ctx.i18n,
                    locale: _ctx.systemLocale,
                    background: "lightcyan",
                    key: [_ctx.glob, _ctx.systemLocale],
                    data: _ctx.best_sellers,
                    link: "#"
                  }, null, 8, ["i18n", "locale", "data"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
})